

























import { Component, Prop, Mixins } from 'vue-property-decorator';
import { SurveyRatingElementOptions } from '@/models/survey-elements/rating-options';
import RatingSelectComponentMixin from '@/mixins/ratingSelectComponentMixin';
import Header from './Header.vue';
import List from './List.vue';
import Item from './Item.vue';
import TextAreaField from '@/components/TextAreaField.vue';

@Component({
  components: {
    Header,
    TextAreaField,
    Item,
    List,
  },
})
export default class RatingSelectExtended extends Mixins(
  RatingSelectComponentMixin
) {
  $refs!: Vue['$refs'] & {
    header: Header;
  };
  @Prop({ type: Array, required: true }) options!: SurveyRatingElementOptions[];
  @Prop({ type: String, required: true }) title!: string;
  @Prop({ type: Object, default: true }) value!: SurveyRatingElementOptions;
  @Prop({ type: String }) externalApiIdentifier!: string | null;

  private selectedItemIndex = 0;
  private optionalValue = null;
  private selectedItemLabel: string | null = null;

  private onChangeHandler(props: any) {
    this.$emit('change', props);
  }

  private setCurrentOption(
    index: number,
    { label, rating }: SurveyRatingElementOptions
  ) {
    if (this.disabled) return;
    this.onChangeHandler({ rating, label });
    this.selectedItemIndex = index;
    this.selectedItemLabel = label;
    this.$nextTick(() => {
      const item = this.$refs.header.$el.querySelector('#ItemLabel');
      const rect = item?.getBoundingClientRect();

      (this.$refs.header.$el as HTMLElement)?.style.setProperty(
        '--wrapper-height',
        `${rect?.height}px`
      );
    });
  }
  mounted() {
    this.setPreselectedOption();
  }

  private setPreselectedOption() {
    if (!this.externalApiIdentifier) return;
    const externalApiIdentifier = this.$route.query[this.externalApiIdentifier];
    if (externalApiIdentifier) {
      const preselectedOption = this.options.find(
        option => `${option.rating}` == externalApiIdentifier
      );
      if (!preselectedOption) return;
      this.setCurrentOption(preselectedOption.rating, preselectedOption);
    }
  }
}
